__turbopack_context__.v({
  "container": "perspectives-checkbox-filter-module-scss-module__MuV0Ua__container",
  "filter": "perspectives-checkbox-filter-module-scss-module__MuV0Ua__filter",
  "filterInput": "perspectives-checkbox-filter-module-scss-module__MuV0Ua__filterInput",
  "filterLabel": "perspectives-checkbox-filter-module-scss-module__MuV0Ua__filterLabel",
  "filterSetHeading": "perspectives-checkbox-filter-module-scss-module__MuV0Ua__filterSetHeading",
  "filters": "perspectives-checkbox-filter-module-scss-module__MuV0Ua__filters",
  "legend": "perspectives-checkbox-filter-module-scss-module__MuV0Ua__legend",
});
